<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">

        <div class="clearfix">
          <h1 class="float-left text-danger display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! You're lost.</h4>
          <p class="text-muted">The page you are looking for was not found.</p>
          <CIcon
              class="c-sidebar-brand-full"
              :src="origin_url+'/favicon.ico'"
              viewBox="0 0 556 134"
          />
          <CButton color="danger" to="/">Go Back to Homepage</CButton>
        </div>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Page404',
  data() {
    return {
      origin_url: window.location.origin
    }
  }
}
</script>
